import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiEndpointService } from 'app/core/services/api-endpoint.service';
import { Observable } from 'rxjs';
import SafeUrlAssembler from 'safe-url-assembler';
import { PostalCode } from '../../models/postal-code.model';

@Injectable()
export class ZipCodeService {

    public constructor(private http: HttpClient, private apiEndpointService: ApiEndpointService) {
    }

    /**
     * Gets address by zip code.
     *
     * @param {string} zipCode
     * @returns {Observable<any>}
     */
    public getAddressByZipCode(zipCode: string): Observable<PostalCode> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.endpointUrls.getAddressByZipCode)
            .param('postalCode', zipCode)
            .toString();
        return this.http.get<PostalCode>(endpoint);
    }

    public patternToRegex(patterns: string): RegExp {
        const regexParts = patterns
            .split(',')
            .map(p => p.trim())
            .map(pattern =>
                pattern
                    .split('')
                    .map(char => {
                        switch (char) {
                            case 'N':
                                return '\\d';
                            case 'A':
                                return '[A-Za-z]';
                            default:
                                return '\\' + char; // Escape literal characters
                        }
                    })
                    .join('')
            );

        const finalRegexStr = `^(${regexParts.join('|')})$`;
        return new RegExp(finalRegexStr, 'i');
    }
}
